import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { FormInputTextModule } from '../../components/form/form-input-text/form-input-text.module';
import { FormInputPasswordModule } from '../../components/form/form-input-password/form-input-password.module';
import { FormInputTextGroupModule } from '../../components/form/form-input-text-group/form-input-text-group.module';
import { FormInputDateModule } from '../../components/form/form-input-date/form-input-date.module';
import { FormInputEditorModule } from '../../components/form/form-input-editor/form-input-editor.module';
import { FormInputDropdownModule } from '../../components/form/form-input-dropdown/form-input-dropdown.module';
import { FormInputNumberModule } from '../../components/form/form-input-number/form-input-number.module';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormInputDateRangeModule } from '../../components/form/form-input-date-range/form-input-date-range.module';
import { FormInputFileModule } from '../../components/form/form-input-file/form-input-file.module';
import { FormInputTextAreaModule } from '../../components/form/form-input-text-area/form-input-text-area.module';
import { DatePickerModule } from 'primeng/datepicker';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    FormInputTextModule,
    FormInputPasswordModule,
    FormInputTextGroupModule,
    FormInputDateModule,
    FormInputEditorModule,
    FormInputDropdownModule,
    FormInputNumberModule,
    CheckboxModule,
    SelectButtonModule,
    FormInputDateRangeModule,
    FormInputFileModule,
    FormInputTextAreaModule,
    DatePickerModule,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    FormInputTextModule,
    FormInputPasswordModule,
    FormInputTextGroupModule,
    FormInputDateModule,
    FormInputEditorModule,
    FormInputDropdownModule,
    FormInputNumberModule,
    CheckboxModule,
    SelectButtonModule,
    FormInputDateRangeModule,
    FormInputFileModule,
    FormInputTextAreaModule,
    DatePickerModule,
  ]
})
export class FormModule { }
